var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"error-404"},[_c('div',{staticClass:"btn"},[_c('div',{staticClass:"home",on:{"click":function($event){return _vm.$router.push('/')}}},[_vm._v("返回首页")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }